import React from 'react';
import { useNavigate } from 'react-router-dom';

function Home() {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
      {/* Header */}
      <header style={{ 
        padding: '20px 40px', 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        background: 'rgba(255,255,255,0.1)',
        backdropFilter: 'blur(10px)'
      }}>
        <h2 style={{ color: 'white', margin: 0 }}>⭐ QR Review</h2>
        <div style={{ display: 'flex', gap: '12px' }}>
          <button 
            className="btn" 
            style={{ background: 'white', color: '#667eea' }}
            onClick={() => navigate('/login')}
          >
            Login
          </button>
          <button 
            className="btn btn-primary"
            onClick={() => navigate('/signup')}
          >
            Get Started
          </button>
        </div>
      </header>

      {/* Hero Section */}
      <div className="container" style={{ 
        textAlign: 'center', 
        paddingTop: '80px',
        paddingBottom: '80px',
        color: 'white'
      }}>
        <h1 style={{ 
          fontSize: '56px', 
          marginBottom: '24px',
          fontWeight: '700',
          lineHeight: '1.2'
        }}>
          AI-Powered Reviews<br/>
          <span style={{ color: '#ffd700' }}>Instantly Generated</span>
        </h1>
        
        <p style={{ 
          fontSize: '20px', 
          marginBottom: '40px',
          opacity: 0.9,
          maxWidth: '600px',
          margin: '0 auto 40px'
        }}>
          Scan QR codes and generate automatic positive reviews with AI. 
          Boost your Google reviews and grow your business!
        </p>

        <button 
          className="btn btn-primary" 
          style={{ 
            fontSize: '18px',
            padding: '16px 48px',
            background: '#ffd700',
            color: '#333',
            fontWeight: '600'
          }}
          onClick={() => navigate('/signup')}
        >
          Start Free Trial →
        </button>

        {/* Features Grid */}
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '24px',
          marginTop: '80px',
          textAlign: 'left'
        }}>
          <div className="card" style={{ background: 'rgba(255,255,255,0.95)' }}>
            <div style={{ fontSize: '40px', marginBottom: '16px' }}>🤖</div>
            <h3 style={{ marginBottom: '12px' }}>AI-Generated Reviews</h3>
            <p style={{ color: '#666', lineHeight: '1.6' }}>
              Powered by Groq AI, customized reviews based on business type
            </p>
          </div>

          <div className="card" style={{ background: 'rgba(255,255,255,0.95)' }}>
            <div style={{ fontSize: '40px', marginBottom: '16px' }}>📱</div>
            <h3 style={{ marginBottom: '12px' }}>QR Code System</h3>
            <p style={{ color: '#666', lineHeight: '1.6' }}>
              Unique QR code for each manager with easy tracking
            </p>
          </div>

          <div className="card" style={{ background: 'rgba(255,255,255,0.95)' }}>
            <div style={{ fontSize: '40px', marginBottom: '16px' }}>⚡</div>
            <h3 style={{ marginBottom: '12px' }}>One-Click Copy</h3>
            <p style={{ color: '#666', lineHeight: '1.6' }}>
              Copy review and submit directly to Google
            </p>
          </div>

          <div className="card" style={{ background: 'rgba(255,255,255,0.95)' }}>
            <div style={{ fontSize: '40px', marginBottom: '16px' }}>📊</div>
            <h3 style={{ marginBottom: '12px' }}>Real-time Stats</h3>
            <p style={{ color: '#666', lineHeight: '1.6' }}>
              Manager-wise review tracking and analytics
            </p>
          </div>

          <div className="card" style={{ background: 'rgba(255,255,255,0.95)' }}>
            <div style={{ fontSize: '40px', marginBottom: '16px' }}>🌐</div>
            <h3 style={{ marginBottom: '12px' }}>Google Integration</h3>
            <p style={{ color: '#666', lineHeight: '1.6' }}>
              Auto-fill business details from Google Places API
            </p>
          </div>

          <div className="card" style={{ background: 'rgba(255,255,255,0.95)' }}>
            <div style={{ fontSize: '40px', marginBottom: '16px' }}>🎯</div>
            <h3 style={{ marginBottom: '12px' }}>Multi-Business</h3>
            <p style={{ color: '#666', lineHeight: '1.6' }}>
              Supports Restaurant, Cafe, Salon, Spa, Hotel and more
            </p>
          </div>
        </div>
      </div>

      {/* How It Works */}
      <div style={{ 
        background: 'white', 
        padding: '80px 20px',
        marginTop: '40px'
      }}>
        <div className="container">
          <h2 style={{ 
            textAlign: 'center', 
            fontSize: '40px', 
            marginBottom: '60px',
            color: '#333'
          }}>
            How It Works?
          </h2>

          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: '40px',
            maxWidth: '1000px',
            margin: '0 auto'
          }}>
            <div style={{ textAlign: 'center' }}>
              <div style={{ 
                width: '80px', 
                height: '80px', 
                background: '#667eea',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 20px',
                fontSize: '32px',
                color: 'white',
                fontWeight: 'bold'
              }}>1</div>
              <h3 style={{ marginBottom: '12px' }}>Signup & Setup</h3>
              <p style={{ color: '#666' }}>Create your business profile</p>
            </div>

            <div style={{ textAlign: 'center' }}>
              <div style={{ 
                width: '80px', 
                height: '80px', 
                background: '#667eea',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 20px',
                fontSize: '32px',
                color: 'white',
                fontWeight: 'bold'
              }}>2</div>
              <h3 style={{ marginBottom: '12px' }}>Add Managers</h3>
              <p style={{ color: '#666' }}>Add managers and generate QR codes</p>
            </div>

            <div style={{ textAlign: 'center' }}>
              <div style={{ 
                width: '80px', 
                height: '80px', 
                background: '#667eea',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 20px',
                fontSize: '32px',
                color: 'white',
                fontWeight: 'bold'
              }}>3</div>
              <h3 style={{ marginBottom: '12px' }}>Scan QR</h3>
              <p style={{ color: '#666' }}>Customer scans the QR code</p>
            </div>

            <div style={{ textAlign: 'center' }}>
              <div style={{ 
                width: '80px', 
                height: '80px', 
                background: '#667eea',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 20px',
                fontSize: '32px',
                color: 'white',
                fontWeight: 'bold'
              }}>4</div>
              <h3 style={{ marginBottom: '12px' }}>AI Review</h3>
              <p style={{ color: '#666' }}>Review is automatically generated</p>
            </div>

            <div style={{ textAlign: 'center' }}>
              <div style={{ 
                width: '80px', 
                height: '80px', 
                background: '#667eea',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 20px',
                fontSize: '32px',
                color: 'white',
                fontWeight: 'bold'
              }}>5</div>
              <h3 style={{ marginBottom: '12px' }}>Submit</h3>
              <p style={{ color: '#666' }}>Copy and submit to Google</p>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div style={{ 
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        padding: '80px 20px',
        textAlign: 'center',
        color: 'white'
      }}>
        <h2 style={{ fontSize: '40px', marginBottom: '24px' }}>
          Ready to Boost Your Reviews?
        </h2>
        <p style={{ fontSize: '18px', marginBottom: '40px', opacity: 0.9 }}>
          Start today and boost your business's online reputation
        </p>
        <button 
          className="btn" 
          style={{ 
            fontSize: '18px',
            padding: '16px 48px',
            background: 'white',
            color: '#667eea',
            fontWeight: '600'
          }}
          onClick={() => navigate('/signup')}
        >
          Get Started Free →
        </button>
      </div>

      {/* Footer */}
      <footer style={{ 
        background: '#1a1a1a',
        color: 'white',
        padding: '40px 20px',
        textAlign: 'center'
      }}>
        <p style={{ margin: 0, opacity: 0.7 }}>
          © 2026 QR Review App. All rights reserved.
        </p>
      </footer>
    </div>
  );
}

export default Home;
